/*
 * @Author: your name
 * @Date: 2021-07-27 20:36:23
 * @LastEditTime: 2021-08-26 19:23:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \welink-open-cloud-wecodesite\welink-devbench-react\src\routes\appdetail\tabs\apiManage\nls\index.js
 */
export const locales = {
  en: require('./en')
};
const messages = {
  applicationID: '应用ID',
  checkServeAPiInstrument: '查看服务端API调用指南',
  hide: '隐藏',
  reset: '重置',
  show: '显示',
  change: '修改',
  testOnline: '在线测试',
  ok: '确定',
  cancel: '取消',
  test: '测试',
  authName: '权限名称',
  authDescription: '权限描述',
  status: '状态',
  operation: '操作',
  eventType: '时间类型',
  Description: '描述',
  callBackUrl: '回调地址',
  opened: '已开通',
  notOpen: '未开通',
  reject: '已驳回',
  approving: '待审核',
  applyAuth: '申请授权',
  cancelAuth: '取消授权'
};
const apply = {
  isRubikCube: '参与微光计划与应用魔方一起快速构建轻应用',
  isPurchase: '应用魔方快速编排你的轻应用'
}

export default {locales, ...messages, ...apply};
